// js
import { persistor, store } from '../store';
import { logoutAuth } from '../store/modules/user/actions';

// Mensagem que o middleware RequireAdm do backend devolve no 403.
// A API usa 403 pra MUITA coisa que não é sessão (validação de formulário,
// e-mail repetido, senha antiga errada...), então só essa mensagem específica
// derruba o login - o resto continua sendo tratado por quem chamou.
const mensagemSemPermissao = 'Acesso restrito a administradores.';

// Derruba a sessão e devolve o usuário pro login.
const encerrarSessao = async () => {
    store.dispatch(logoutAuth());
    // flush garante que o redux-persist grave o logout antes de trocar de página.
    await persistor.flush();
    window.location.replace('/');
};

// Wrapper único de fetch do painel: toda chamada de `services/` passa por aqui.
// Quando o backend responde 401 (sem token, token inválido ou expirado) ou o
// 403 do RequireAdm, manda o usuário de volta ao login em vez de deixar a tela
// quebrar tentando ler um `result` que não veio.
const apiFetch = async (url: string, configs?: RequestInit): Promise<Response> => {
    const response = await fetch(url, configs);

    if (response.status === 401) {
        await encerrarSessao();
        return response;
    }

    if (response.status === 403) {
        try {
            const json = await response.clone().json();
            if (json?.message === mensagemSemPermissao) {
                await encerrarSessao();
            }
        } catch (error) {
            // Corpo não-JSON: não há mensagem pra conferir, segue o fluxo normal.
        }
    }

    return response;
};

export default apiFetch;
